import { useCallback } from 'react';
import getUnitSelector from '/business/shared/state/selectors/units/getUnitSelector';
import { useSelector } from 'react-redux';
import getRefrigerantsSelector from '/business/shared/state/selectors/form/getRefrigerantsSelector';
import getEmissionWasteTypesSelector from '/business/shared/state/selectors/form/getEmissionWasteTypesSelector';
import getDeicingChemicalTypesSelector from '/business/shared/state/selectors/form/getDeicingChemicalTypesSelector';
import { capitalGoodsSpendCategories } from '/business/shared/components/questions/scope3/goods/capitalGoods/helpers/helpers';
import { purchasedGoodsAndServicesSpendCategories } from '/business/shared/components/questions/scope3/goods/purchasedGoods/helpers/helpers';

export default function useGetEmissionTypeLabel() {
  const unitData = useSelector(getUnitSelector);
  const refrigerants = useSelector(getRefrigerantsSelector);
  const wasteTypes = useSelector(getEmissionWasteTypesSelector);
  const deicing = useSelector(getDeicingChemicalTypesSelector);

  const formatFuelId = useCallback(
    (rawFuelId: string, useSentenceVariant = false, apiQuestionId = '') => {
      const enableLegacyPurchasedGoods = apiQuestionId.includes('purchased-goods');
      const enableLegacyWaste = apiQuestionId.includes('wasteops');
      const enableLegacyCapitalGoods = apiQuestionId.includes('capital-goods');
      const enableLegacyRefrigerants = apiQuestionId.includes('refrigerants');
      const enableLegacyDeicing = apiQuestionId.includes('deicing');

      if (unitData && unitData.collection && unitData.collection.length > 0) {
        const needle = unitData.collection.find((needle) => {
          return needle.systemId === rawFuelId;
        });
        // Scan new sys
        if (needle) {
          if (useSentenceVariant) {
            return needle.labelInSentence;
          }
          return needle.label;
        }
        // Scan legacy - refrigerants
        if (enableLegacyRefrigerants) {
          const refrigerantLegacyNeedle = refrigerants.find((fridge: { name: string; displayName: string }) => {
            return fridge.name === rawFuelId;
          });
          if (refrigerantLegacyNeedle) {
            return refrigerantLegacyNeedle.displayName;
          }
        }
        // Scan legacy - Waste
        if (enableLegacyWaste) {
          const wasteLegacyNeedle = wasteTypes.find((waste: { name: string; displayName: string }) => {
            return waste.name === rawFuelId;
          });
          if (wasteLegacyNeedle) {
            return wasteLegacyNeedle.displayName;
          }
        }
        // Scan legacy - Deicing
        if (enableLegacyDeicing) {
          const deicingLegacyNeedle = deicing.find((ice: { name: string; displayName: string }) => {
            return ice.name === rawFuelId;
          });
          if (deicingLegacyNeedle) {
            return deicingLegacyNeedle.displayName;
          }
        }

        // Legacy - hardcoded - capital goods
        if (enableLegacyCapitalGoods) {
          const capGoodNeedle = capitalGoodsSpendCategories.find((capGood) => {
            return capGood.name === rawFuelId;
          });
          if (capGoodNeedle) {
            return capGoodNeedle.displayName;
          }
        }
        // Legacy - hardcoded - purchased goods
        if (enableLegacyPurchasedGoods) {
          const purchasedGoodNeedle = purchasedGoodsAndServicesSpendCategories.find((purchGood) => {
            return purchGood.name === rawFuelId;
          });
          if (purchasedGoodNeedle) {
            return purchasedGoodNeedle.displayName;
          }
        }
      }
      return rawFuelId;
    },
    [unitData],
  );
  return {
    formatFuelId,
  };
}
